import './Tooltip-71d21790.css';

var classes = {"Tooltip":"prc-TooltipV2-Tooltip-cYMVY","\\":"prc-TooltipV2----ketfx","tooltip-appear":"prc-TooltipV2-tooltip-appear-hLf77"};

export { classes as default };
